/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.CreateUserResponse,
  createUser: (params: vp.CreateUserRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const userPostCreateUser: ApiHook = ({ api }) => {
  const [shouldCreateUser, setShouldCreateUser] = useState(false);
  const source = axios.CancelToken.source();
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [params, setParams] = useState<vp.CreateUserRequest>({
    EmailAddress: '',
    SendEmail: false,
    Role: '',
  });
  const [response, setResponse] = useState<vp.CreateUserResponse>({
    Success: false,
    ErrorMessage: '',
    Username: '',
    Password: '',
  });
  useEffect(() => {
    if (!shouldCreateUser) return () => {};

    const CreateUser = async () => {
      setDataFetchingInfo(true, 'creating user', 'fullScreen');
      const res = await api.postCreateUser(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldCreateUser) void CreateUser();
    setShouldCreateUser(false);
    return () => {
      source.cancel();
    };
  }, [shouldCreateUser]);
  return [
    response,
    (_params: vp.CreateUserRequest) => {
      setParams(_params);
      setShouldCreateUser(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        Username: '',
        Password: '',
      });
      setShouldCreateUser(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(userPostCreateUser);
